import { isRequired } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.integrations && values.integrations.length) {
    const integrations = values.integrations;
    const integrationsArrayErrors = [];

    integrations.forEach((item, index) => {
      const integrationsErrors = {};

      if (isRequired(item.platform, true)) {
        integrationsErrors['platform'] = 'Platform is required';
        integrationsArrayErrors[index] = integrationsErrors;
      }

      if (isRequired(item.titleOnPlatform || '', true)) {
        integrationsErrors['titleOnPlatform'] =
          'Activity on the platform is required';
        integrationsArrayErrors[index] = integrationsErrors;
      }
    });

    if (integrationsArrayErrors.length) {
      errors.integrations = integrationsArrayErrors;
      errors.integrations = {
        ...integrationsArrayErrors,
        _error: { ...integrationsArrayErrors }
      };
    }
  }

  return errors;
};

export default validate;
